var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectionNoteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.81783H4",
    stroke: "#FCB816",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.99947H4",
    stroke: "#FCB816",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.18111H4",
    stroke: "#FCB816",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68323 1.50217C3.68364 1.50217 3.68405 1.50217 3.68446 1.50216L5.99153 1.50109L7.57586 1.50034L8.09781 1.50009L8.24403 1.50002L8.28255 1.50001L8.29243 1.5L8.29493 1.5L8.29553 1.5L8.29555 1.5L8.29566 1.5C8.29567 1.5 8.29569 1.5 8.29571 1.5C9.03286 1.50004 9.57725 1.71724 9.93288 2.0495C10.2852 2.37863 10.5 2.86474 10.5 3.50244V8.49756C10.5 9.13174 10.2869 9.6158 9.93737 9.94451C9.58477 10.2761 9.04557 10.4941 8.31618 10.4984C8.31577 10.4984 8.31535 10.4984 8.31494 10.4984L6.0077 10.4992L4.42351 10.4997L3.90163 10.4999L3.75542 10.5L3.71691 10.5L3.70703 10.5L3.70453 10.5H3.7039H3.70387C3.70383 10.5 3.70379 10.5 3.70375 10.5C2.96657 10.5 2.42235 10.2828 2.06687 9.95056C1.71474 9.62146 1.5 9.13534 1.5 8.49756V3.50244C1.5 2.86818 1.71302 2.38429 2.06233 2.05576C2.41474 1.7243 2.95377 1.50648 3.68323 1.50217Z",
    stroke: "#FCB816",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionNoteIcon);
export default __webpack_public_path__ + "static/media/connectionNoteIcon.9c187a1299d028c1cf9585735b981b94.svg";
export { ForwardRef as ReactComponent };